<template>
  <div>
    <div class="card">
      <div class="card-content">
        <h4 class="card-title">Lista de Declaraciones</h4>
        <div class="row align-items-end">
          <div v-if="rol === 4 || rol === 5 || rol === 14">
          </div>
          <div v-else class="col-md-6">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias1" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-2">
            <label>Declaración </label><br>
            <el-select clearable class="select-default" filterable name="declaracion" placeholder="Declaracion" v-model="model.tipo_declaracion">
              <el-option v-for="option in tiposDeclaracion" class="select-default" :value="option.id" :label="option.tipo_declaracion" :key="option.tipo_declaracion">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-2">
            <label>Año</label><br>
            <el-select clearable class="select-default" filterable name="periodo" placeholder="Periodo" v-model="model.periodo">
              <el-option v-for="option in periodos2" class="select-default" :value="option.year" :label="option.year" :key="option.year">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-2">
            <button @click="getDeclaraciones" class="btn btn-fill btn-success pull-right">
          Buscar
        </button>
          </div>

        </div>


        <div>
          <br>
          <div class="offset-md-6 col-sm-6 col-md-6 col-lg-6">
            <!-- <b-form-group label-cols-sm="3" class="mb-0">
              <b-input-group>
                <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
              </b-input-group>
            </b-form-group> -->
            <v-text-field v-model="search" append-icon="mdi-magnify" label="" class="busqueda" placeholder="Buscar RFC" clearable single-line hide-details @click:clear="clearSearch" @input="searchDeclarantes"></v-text-field>
          </div>
          <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <v-data-table
                            :headers="headers"
                            :items="filtro_usuarios"
                            :footer-props="listSize"
                            :options.sync="pagination"
                            :server-items-length="totalItems"
                            @update:options="getDeclaraciones"
                            :loading="loading"
                            item-key="id"
                            :fixed-header="true"
                            class="">
              <!-- <v-data-table :headers="headers" :items="filtro_usuarios" :items-per-page="5" :search="filter" class="" :fixed-header="true"> -->
                <template v-slot:item.acciones="{ item }">
                  <div class="d-flex justify-content-center" v-if="getKey('permisos').includes(25) || rol == 1">

                    <b-button @click.prevent="descargaDeclaracion(item,false)" class="btn-s edit mr-2" variant="success" v-b-popover.hover.top="'Descargar Declaración Completa'">
                      <i class="ti-download"></i></b-button>

                    <b-button @click.prevent="descargaDeclaracion(item,true)" class="btn-s edit mr-2" variant="primary" v-b-popover.hover.top="'Descargar Declaración Pública'">
                      <i class="ti-download"></i></b-button>

                    <b-button @click.prevent="reactivar(item)" class="btn-s delete" variant="danger" v-b-popover.hover.top="'Reactivar declaración'" v-if="rol == 1">
                      <i class="ti-unlock"></i></b-button>
                  </div>
                  <div v-else></div>
                </template>
                <template v-slot:item.id="{ item }">
                  <div>{{ dateFormat(item.fecha) }}</div>
                </template>
                <template v-slot:item.titular_id="{ item }">
                  <div>{{ filterCatalog(item.titular_id, titular_adeudo) }}</div>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import Vue from 'vue'
import {
  // Table,
  // TableColumn,
  Select,
  Option
} from 'element-ui'
// import PPagination from 'src/components/UIComponents/Pagination.vue'

export default {
  components: {
    // PPagination,
    // [Table.name]: Table,
    // [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data () {
    return {
      model: {
        tipo_declaracion: 1,
        dependencia_id: null,
        periodo: null
      },
      rol: '',
      filter: null,
      loading: false,
      search: '',
      current_search: '',
      awaitingSearch: false,
      listSize: {
        itemsPerPageOptions: [10, 25, 50, 100],
        showFirstLastPage: true
      },
      pagination: {
        page: 1,
        itemsPerPage: 10,
        lastPage: null
      },
      totalItems: 0,
      currentPage: 1,
      perPage: 50,
      periodos2: [],
      rows: null,
      tiposDeclaracion: [{
        'id': 1,
        'tipo_declaracion': 'Inicial'
      }, {
        'id': 2,
        'tipo_declaracion': 'Anual'
      }, {
        'id': 3,
        'tipo_declaracion': 'Final'
      }],
      list_cumplimiento: [],

      filtro_usuarios: [],

      searchQuery: '',
      headers: [{
        text: 'Fecha de presentación',
        value: 'id',
        align: 'center'
      },
      {
        text: 'Tipo',
        value: 'tipo',
        align: 'center'
      },
      {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      },
      {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Correo Laboral',
        value: 'correo',
        align: 'center'
      }],
      propsToSearch: ['rfc', 'nombres'],
      tableColumns: [{
        prop: 'id',
        label: 'Dec',
        minWidth: 150,
        vif: false
      },
      {
        prop: 'rfc',
        label: 'RFC',
        minWidth: 150,
        vif: true
      },
      {
        prop: 'nombres',
        label: 'Nombre',
        minWidth: 100,
        vif: true
      }
      ]
    }
  },
  computed: {

  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.rows = filteredItems.length
      this.currentPage = 1
    },
    dateFormat: function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    checkPermissions () {
      let permiso = [1, 25]
      if (!this.getKey('permisos').some(r => permiso.includes(r))) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    // getDependencias () {
    //   var v = this
    //   this.$http.get('cat_ente_publico').then(
    //     response => {
    //       this.dependencias = response.data.entes_publicos
    //       this.dependencias.unshift({
    //         'codigo': 'T',
    //         'id': 0,
    //         'valor': 'Todas'
    //       })
    //     },
    //     error => {
    //       this.StepError(error)
    //     }
    //   )
    // },
    getPeriodos2 () {
      var v = this
      this.$http.get('getPeriodos').then(
        response => {
          this.periodos2 = response.data.periodos
          let anio = [...response.data.periodos].shift()
          // console.log(anio.year)
          if (anio.year) {
            this.model.periodo = anio.year
          }
        },
        error => {
          this.StepError(error)
        }
      )
    },
    clearSearch () {
      this.search = ''
      this.getDeclaraciones()
    },
    searchDeclarantes (val) {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.getDeclaraciones()
          this.awaitingSearch = false
        }, 1000) // 1 sec delay
      }
      this.awaitingSearch = true
    },
    getDeclaraciones () {
      this.loading = true

      let page = this.pagination.page
      let ente = this.model.dependencia_id
      let rfc_ = ''

      if (this.current_search !== this.search) {
        this.current_search = this.search
        page = 1
      }

      if (this.search && this.search.length >= 4) {
        rfc_ = this.search
      }

      var params = {
        params: {
          page: page,
          itemsPerPage: this.pagination.itemsPerPage,
          filters: {
            ente: ente,
            rfc: rfc_,
            tipo_declaracion: this.model.tipo_declaracion,
            periodo: this.model.periodo
          }
        }
      }

      this.$http.get('ldeclaraciones', params).then(
        response => {
          this.loading = false
          this.list_cumplimiento = []

          var lista = response.data

          this.totalItems = Number(lista.total)
          this.pagination.page = Number(lista.current_page)
          this.pagination.lastPage = Number(lista.last_page)


          lista.data.forEach((value, key) => {
            this.list_cumplimiento.push({
              'ip_id': value.ipid,
              'declaracion_id': value.decid,
              'bit_id': value.bit_id,
              'fecha': value.fecha.toUpperCase(),
              'rfc': value.rfc.toUpperCase(),
              'tipo': value.tipo.toUpperCase(),
              'nombres': value.nombres.toUpperCase() + ' ' + value.primer_apellido.toUpperCase() + ' ' + value.segundo_apellido.toUpperCase(),
              'entidad': value.ente.toUpperCase(),
              'correo': value.correo.toLowerCase()
            })
          })

          this.filtro_usuarios = this.list_cumplimiento
        },
        error => {
          this.loading = false
          this.StepError(error)
        }
      )
    },
    descargaDeclaracion (row, publica) {
      this.Ask('¿Desea descargar ésta declaración?', () => {
        let cargando = this.$swal({
          showConfirmButton: false,
          type: 'warning',
          title: this.texto,
          text: 'Esta información es confidencial y tu acceso ha sido registrado por políticas de seguridad',
          showCloseButton: this.close
        })

        var params = {
          id: row.bit_id,
          ip_id: row.ip_id,
          declaracion_id: row.declaracion_id,
          publica: publica
        }

        this.$http.post(this.$http.options.root + 'descargaDeclaracion', params, {
          responseType: 'arraybuffer'
        }).then(
          response => {
            this.downloadFile(response, 'Declaración')
            cargando.close()
          },
          error => {
            this.StepError(error)
            cargando.close()
          }
        )
      })
    },
    reactivar (row) {
      this.Ask('¿Desea reactivar ésta declaración?', () => {
        this.$http.get('declaracion/reactiva/' + row.declaracion_id).then(
          response => {
            this.StepOk('Reactivada Correctamente')
            this.getDeclaraciones()
          },
          error => {
            this.StepError(error)
          }
        )
      })
    }
  },
  created () {
    // this.getDependencias()

    this.model.dependencia_id = this.getKey('ente_publico_id')

    this.getPeriodos2()
    this.rol = this.getKey('role')

    if (this.rol != 4) {
      this.headers.unshift({
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      })
    }

    this.checkPermissions()
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/ListDeclaraciones.vue